import React from 'react';
import './style.css';

// import feature2 from '../../assets/icons/man-with-suitcase.svg';
// import feature3 from '../../assets/icons/land.svg';
import AddIcon from 'react-icons/lib/md/flight-land';
import PassengerIcon from 'react-icons/lib/md/airline-seat-recline-extra';
import FlightIcon from 'react-icons/lib/md/airplanemode-active';


const FeaturedSolutions = () => (
    <div className="container">
        <div className="row">
            <div className={'col-sm-12 mt-5 mb-5'}>
                <h4 className='text-center mb-2'>FEATURED SOLUTIONS</h4>
            </div>
        </div>
        <div className=" row mb-15">
            <div  className={'col-md -4 feature-item animated p-3 fadeInUp bd-right pl-5 pr-5 pb-5 pt-5'}>
                <div className="text-center">
                    <AddIcon color="#dc0d18" size="50"/>
                    {/*<img src={feature3} alt="Airport Management" className='img-icon'/>*/}
                </div>
                <h5 className='text-center mt-3 mb-3'>Digital Airport Management System</h5>
                <p className=' text-center'>
                    Achieving seamless integrated operations between systems to minimize cost and improve airport-wide management.
                </p>
            </div>
            <div className={' col-md -4 feature-item animated p-3 fadeInUp bd-right pl-5 pr-5 pb-5 pt-5'}>
                <div className="text-center">
                    <PassengerIcon color="#dc0d18" size="50"/>
                    {/*<img src={feature2} alt="Passenger Information System" className='img-icon'/>*/}
                </div>
                <h5 className='text-center mt-3 mb-3'>Passenger Information System</h5>
                <br/>
                <p className='text-center'>
                    Delivering data management systems to increase transparency and improve operational efficiency.
                </p>
            </div>
            <div className={'col-md -4 feature-item animated p-3 fadeInUp pl-5 pr-5 pb-5 pt-5'}>
                <div className="text-center">
                    <FlightIcon color="#dc0d18" size="50"/>
                    {/*<img src={feature3} alt="Flight Information System" className='img-icon'/>*/}
                </div>
                <h5 className='text-center mt-3 mb-3'>Flight Information System</h5>
                <br/>
                <p className=' text-center'>
                    Delivering  flight management systems to increase safety and billing accuracy for air navigation service providers.
                </p>
            </div>
        </div>
    </div>
);

export default FeaturedSolutions;



// WEBPACK FOOTER //
// ./src/views/home/featured.js